// Single source of truth for what a customer gets when they unlock a project
// with the one-off A$29.99 fee. Imported by:
//   - /pages/Pricing.jsx  (the browse-time promise)
//   - /components/visualiser/PaywallCard.jsx  (the payment-time promise)
//   - /pages/UnlockSuccess.jsx  (the post-payment confirmation)
//
// Keeping these lists in one place prevents the drift that was previously
// present between the three surfaces (Pricing = 7 items, Paywall = 4 items,
// UnlockSuccess = 3 items). Any future edit to the promise must be made here.
//
// R-04 (2026-07-04) — Commercial Readiness "Before Launch" batch.

/** Complete list of benefits included with a project unlock. */
export const UNLOCK_BENEFITS = [
  "Unlimited paint colours and renders",
  "Up to 8 photos per project (one per angle)",
  "Designer schemes + Scheme Mode (multi-surface)",
  "Before / after comparison slider",
  "HD watermark-free download",
  "Paint Specification PDF for your painter",
  "Lifetime access to this project",
];

/** Shorter list surfaced in tight spaces (e.g. UnlockSuccess polling card). */
export const UNLOCK_BENEFITS_SHORT = [
  "Unlimited paint colours and renders",
  "Up to 8 photos per project",
  "Paint Specification PDF for your painter",
  "Lifetime access to this project",
];

/** Canonical human-readable entitlement string used in copy. */
export const UNLOCK_ENTITLEMENT = "One-time · per project · lifetime access";
